var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { coreBasicApiUrlPrefix } from '@cores/constants/envConfig';
import psHttp from '@patsnap/common-ps-http';
import { PersistentCacheConfig, PersistentCacheStrategy, requestConfigWrapper } from '@patsnap/common-ps-http/dist/PersistentCache';
import { LegalStatusApiDto } from '../types/legal-status-api-dto.interface';
const persistCacheConfInst = new PersistentCacheConfig({
    strategy: PersistentCacheStrategy.CACHE_FIRST_WITH_SILENT_UPDATE, // 缓存策略，见下表
    detectAllowCachingHook: PersistentCacheConfig.defaults.detectAllowCachingHook_statusdata,
});
let LegalStatusApiImpl = class LegalStatusApiImpl {
    constructor(_legalStatusApiDto) {
        this._legalStatusApiDto = _legalStatusApiDto;
    }
    getLegalStatusConfig() {
        return psHttp(requestConfigWrapper({
            url: `${coreBasicApiUrlPrefix}/analytics/config/legal-status`,
            method: 'GET',
            cache: true,
            transformCode: true,
        }, persistCacheConfInst)).then(({ data }) => {
            const legalConfig = data.data;
            return this._legalStatusApiDto.formateLegalConfig(legalConfig);
        });
    }
};
LegalStatusApiImpl = __decorate([
    injectable(),
    __param(0, inject(LegalStatusApiDto)),
    __metadata("design:paramtypes", [typeof (_a = typeof LegalStatusApiDto !== "undefined" && LegalStatusApiDto) === "function" ? _a : Object])
], LegalStatusApiImpl);
export { LegalStatusApiImpl };
